import { Component, Input } from '@angular/core';
import { NgForOf } from '@angular/common';
import { Colorset, ColorsetTemplate } from '../../../models/colorset';

/**
 * Preview of a colorset's colors, either as single dots or as a compact,
 * segmented strip (e.g. for dropdowns).
 */
@Component({
  selector: 'app-colors',
  standalone: true,
  imports: [NgForOf],
  templateUrl: './colors.component.html',
  styleUrl: './colors.component.scss',
})
export class ColorsComponent {
  @Input() colorset!: Colorset | ColorsetTemplate;
  @Input() variant: 'dots' | 'strip' = 'dots';
}
